// import { Button } from 'alm-react-components';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppName, APPROUTES } from '../../assets/constants/constants';
import LSLogo from '../../assets/images/lnner-stance-logo.svg';
import { headerLogUrl } from '../../lib/utils';
import SelectDropdown from './SelectDropdown';
// import defaultUserImg from "../../assets/images/user-mtbg.svg";
// import ChevronRight from "../../assets/images/chevron-right.svg";
// import editprofileIcon from "../../assets/images/svgicons/edit-profile-icon.svg";

// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuLabel,
//   DropdownMenuTrigger,
//   DropdownMenuItem,
//   Avatar,
//   AvatarImage,
// } from "alm-react-components";
import { BASE_URL } from '../../services/urls';

function RegistrationHeader({showButton, showLanguageSelector}: any) {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const location = useLocation();
  const baseUrl:string = BASE_URL

  const nav=()=>{
    const urlto = headerLogUrl()
    if(![APPROUTES.profile,APPROUTES.personalizedUpdates,APPROUTES.verificationAccount,APPROUTES.verificationSignIn,APPROUTES.startLearning].includes(location.pathname) )
    navigate(urlto);
  }
  return (
    <nav className="bg-white border-gray-200 dark:bg-black fixed z-[4] w-full top-0">
      <div className="w-full flex items-center justify-between mx-auto py-4 xl:px-32 lg:px-8 md:px-8 px-5 z-[100] relative">
        <div className="flex items-center lg:justify-start w-full">
          <a  onClick={()=>nav()} className={`flex items-center lg:mr-12 md:space-x-3 rtl:space-x-reverse text-un-none ${![APPROUTES.profile,APPROUTES.personalizedUpdates,APPROUTES.verificationAccount,APPROUTES.verificationSignIn,APPROUTES.startLearning].includes(location.pathname) ? 'cursor-pointer':'' }`}>
            <img src={LSLogo} className=" h-8 lg:h-12 bg-fillNavbar cursor-pointer" alt={AppName} />
            <span className="self-center max-md:text-base lg:text-xl font-opensansSemiBold whitespace-nowrap dark:text-white lg:block cursor-pointer sm:ml-2 max-sm:ml-2">
              <span dangerouslySetInnerHTML={{ __html: t('Header.innerStance') }} />
            </span>
          </a>
        </div>

        <div className="flex items-center md:order-2 space-x-3 md:space-x-3 rtl:space-x-reverse">
          {showLanguageSelector === true && (baseUrl?.indexOf('dev') !== -1 || baseUrl?.indexOf('perf') !== -1) && (
            <div className="flex md:justify-start sm:justify-center header-language-dropdown language-dropdown font-opensansLight">
              <SelectDropdown/>
            </div>
          )}
          {showButton === true && (
            <>
              {/* <div className="md:hidden">
                  <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Avatar
                          className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
                          id="user-menu-button"
                          aria-expanded="false"
                          data-dropdown-toggle="user-dropdown"
                          data-dropdown-placement="bottom"
                        >
                          <AvatarImage
                            className="object-cover"
                            src={defaultUserImg}
                            alt="User Image"
                          />
                        </Avatar>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent className="w-56 py-0 z-[50] px-0 dark:bg-navActive mr-3">
                        <DropdownMenuLabel className="px-0">
                            <DropdownMenuItem
                              onClick={() => {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                                navigate("/");
                              }}
                              className="cursor-pointer p-3 py-4 justify-between items-start flex-row border-b-[1px] border-gray-700 rounded-none"
                            >
                              <div className="flex ">
                                <img
                                  className="w-[20px] h-[20px] mr-3"
                                  alt="Sign in"
                                  src={editprofileIcon}
                                />
                                <div className="font-medium"><span dangerouslySetInnerHTML={{ __html: t('LogIn.loginHeading') }} /></div>
                              </div>
                              <img
                                className="w-[16px] h-[16px]"
                                alt="No Image"
                                src={ChevronRight}
                              />
                            </DropdownMenuItem>
                            <DropdownMenuItem
                              onClick={() => {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                                navigate("/sign-up");
                              }}
                              className="cursor-pointer p-3 py-4 justify-between items-start flex-row border-b-[0px] border-gray-700 rounded-none"
                            >
                              <div className="flex ">
                                <img
                                  className="w-[20px] h-[20px] mr-3"
                                  alt="Sign Up"
                                  src={editprofileIcon}
                                />
                                <div className="font-medium"><span dangerouslySetInnerHTML={{ __html: t("SignUp.signUp") }} /></div>
                              </div>
                              <img
                                className="w-[16px] h-[16px]"
                                alt="No Image"
                                src={ChevronRight}
                              />
                            </DropdownMenuItem>
                        </DropdownMenuLabel>
                      </DropdownMenuContent>
                  </DropdownMenu>
              </div> */}
            {/* {!CorporateUser && <div className="max-md:hidden md:flex md:order-2 space-x-3 md:space-x-3">
              <Button
                onClick={() => navigate('/')}
                variant={'outline'}
                className="inline-flex dark:bg-transparent items-center justify-center rounded-sm text-sm md:text-base my-0 py-4 px-2 md:px-4 md:w-28 h-10"
              >
                <span dangerouslySetInnerHTML={{ __html: t('LogIn.loginHeading') }} />
              </Button>
              <Button
                onClick={() => navigate('/sign-up')}
                variant={'default'}
                className="inline-flex items-center justify-center rounded-sm text-sm md:text-base my-0 py-4 px-2 md:px-4 md:w-28 h-10"
              >
                <span dangerouslySetInnerHTML={{ __html: t("SignUp.signUp") }} />
              </Button>
            </div>} */}
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default RegistrationHeader;
